import React from "react";
import styled from "styled-components";
import Paragraph from "../components/Paragraph";
import Col from "../components/Col";
import SubHeadline from "../components/SubHeadline";
import Strong from "../components/Strong";
import Button from "../components/Button";
import colors from "../config/colors";

const A = styled.a`
  color: ${colors.text};
  font-size: 1.2rem;
  text-decoration: none;
`;

export default () => (
  <Col>
    <SubHeadline>
      <Strong>MOBIL</Strong>
    </SubHeadline>
    <A href="tel:01608855112">0160 8855112</A>
  </Col>
);



// WEBPACK FOOTER //
// ./src/components/ContactMobile.js